/**
 * vidIQ Vision for YouTube
 *
 * A YouTube analytics tool, so detecting it flags the visitor as a creator or marketer.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 3.205.1.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'pachckjkecffpdphbpmfolblodfkgbhl';
export const vidiq: ExtensionDefinition = {
  id: ID,
  name: "vidIQ Vision for YouTube",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3000000,
  notes: "A YouTube analytics tool, so detecting it flags the visitor as a creator or marketer.",
  signals: [
    { id: 'war-billing-popup-html', kind: 'web-accessible-resource',
      description: 'Fetch billing-popup.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'billing-popup.html') },
    { id: 'war-bridge-html', kind: 'web-accessible-resource',
      description: 'Fetch bridge.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'bridge.html') },
  ],
};
